import { render, staticRenderFns } from "./UserDetailsAdministrationUserRightHelpBox.vue?vue&type=template&id=01d0ddc0&"
import script from "./UserDetailsAdministrationUserRightHelpBox.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAdministrationUserRightHelpBox.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAdministrationUserRightHelpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports